<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter" title="Acknowledgments">
<header>
<h2 class="chnum" epub:type="title"><a id="page_5"><em>ACKNOWLEDGMENTS</em></a></h2><a id="page_5">
</a></header><a id="page_5">
<p class="noindent"><em>Atlanta Review:</em> “Oldguy: Superhero”; <em>Black Renaissance Noir:</em> “Oldguy: Superhero—The End?” (retitled “Oldguy: Superhero, Jumper”), “Oldguy: Superhero vs. His Nemesis (II)”; <em>Epoch:</em> “Oldguy: Superhero vs. His Nemesis”; <em>Green Mountains Review:</em> “Oldguy: Superhero’s Combat Moves,” “Oldguy: Superhero vs. His Nemesis (III),” “Oldguy: Superhero’s Last Will and Testament,” “Oldguy: Superhero Sings,” “Oldguy: Superhero, Noir,” “Oldguy: Superhero, Scoutmaster,” “Oldguy: Superhero vs. Magneto,” “Oldguy: Superhero Gets a Physical,” “Oldguy: Superhero Gives Away Professional Secrets,” “Oldguy: Superhero vs. The Blob,” “Oldguy: Superhero, Fashion Plate,” “Oldguy: Superhero Decides to Hang it Up,” “Oldguy: Superhero Attends the Associated Superheroes Conference,” “Oldguy: Superhero, Top Eliminator,” “Oldguy: Superhero, Homie,” “Oldguy: Superhero—His Utility Belt”; <em>I-70 Review:</em> “Oldguy: Superhero Bends an Elbow”; <em>New Letters:</em> “Oldguy: Superhero Discovers his Brother,” “Oldguy: Superhero—His Origin”; <em>Plume:</em> “Oldguy: Superhero, Undercover”; <em>Rattle:</em> “Oldguy: Superhero vs. The Riddler,” “Oldguy: Superhero, Associate,” “Oldguy: Superhero, Steady Hand”; and <em>The American Journal of Poetry:</em> “Oldguy: Superhero Takes His Driver’s Test.”</p>
</a><a id="page_6">
</a></section><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Ack.vue?72d62394